import { ROUTE_PERMISSION } from '../../config/permission.config.js'

export default [
  { path: '', redirect: 'overview' },
  {
    path: 'overview',
    name: 'GroupOverview',
    component: () => import('../../views/group/OverviewPage.vue'),
    meta: {
      requiresAuth: true,
      layoutRoot: true,
      title: 'Yhteenveto - Vuokranet',
    },
  },
  {
    path: 'tehtavat/hallinta',
    name: 'GroupTicketManagement',
    component: () => import('../../views/group/tickets/ManagementPage.vue'),
    meta: {
      requiresAuth: true,
      permission: ROUTE_PERMISSION.G_TICKET_MANAGEMENT,
      scopeTicketGroups: true,
      title: 'Tehtävien hallinta - Vuokranet',
    },
  },
  {
    path: 'tehtavat/hallinta/uusi',
    name: 'GroupTicketEditorNew',
    component: () => import('../../views/group/tickets/EditorPage.vue'),
    meta: {
      requiresAuth: true,
      permission: ROUTE_PERMISSION.G_TICKET_MANAGEMENT,
      ticketResourceCreate: true,
      title: 'Uusi tehtävä - Vuokranet',
    },
  },
  {
    path: 'tehtavat/hallinta/:id/attachment/:attachmentId',
    name: 'GroupTicketAttachmentPdf',
    component: () => import('../../views/PdfViewerPage.vue'),
    meta: {
      requiresAuth: true,
      permission: ROUTE_PERMISSION.G_TICKET_MANAGEMENT,
      title: 'PDF - Vuokranet',
    },
  },
  {
    path: 'tehtavat/hallinta/:id',
    name: 'GroupTicketEditor',
    component: () => import('../../views/group/tickets/EditorPage.vue'),
    meta: {
      requiresAuth: true,
      permission: ROUTE_PERMISSION.G_TICKET_MANAGEMENT,
      title: 'Muokkaa tehtävää - Vuokranet',
    },
  },
  {
    path: 'tehtavat/seuranta',
    name: 'GroupTicketTracking',
    component: () => import('../../views/group/tickets/TrackingPage.vue'),
    meta: {
      requiresAuth: true,
      permission: ROUTE_PERMISSION.G_TICKET_TRACKING,
      scopeTicketGroups: true,
      title: 'Tehtävien seuranta - Vuokranet',
    },
  },
  {
    path: 'tehtavat/asetukset',
    name: 'GroupTicketSettings',
    component: () => import('../../views/group/tickets/SettingsPage.vue'),
    meta: {
      requiresAuth: true,
      permission: ROUTE_PERMISSION.G_TICKET_SETTINGS,
      scopeTicketGroups: true,
      title: 'Tehtävien asetukset - Vuokranet',
    },
  },
]
